exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main {\n  max-width: 1147px;\n  margin: .5em auto .5em auto;\n  letter-spacing: -0.2px; }\n\n.connectButton {\n  text-align: center; }\n  .connectButton button {\n    border-radius: 6px;\n    background-color: #5ab0ef;\n    padding: 15px 36px 15px 36px;\n    font-size: 20px;\n    font-weight: 500;\n    color: #ffffff;\n    display: inline-block;\n    margin: 1em;\n    cursor: pointer;\n    border: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Status/status.scss
// module id = 927
// module chunks = 1